































import { Component, Vue } from 'vue-property-decorator';
import { EXERCISE_ADD_ACTION } from '@/store/exercise.store';
import { RouteName } from '../router';
import { ExerciseMetric } from '../models/exercise.model';

@Component
export default class ExerciseList extends Vue {
  name = '';
  description = '';
  metric = ExerciseMetric.weight;

  ExerciseMetric = ExerciseMetric;

  get title() {
    // Title should probably be in component that is not a route
    return this.$route.name;
  }

  addExercise() {
    if (this.name) {
      const exercise = {
        name: this.name,
        description: this.description,
        metric: this.metric,
      };
      this.$store.dispatch(EXERCISE_ADD_ACTION, {
        database: this.$database,
        exercise,
      });

      this.$router.push({ name: RouteName.ExerciseList });
    }
  }
}
